import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlayMarket = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 26,
	viewBox: "0 0 23 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.454487 0.393748C0.166397 0.705469 0 1.18178 0 1.80522V23.9174C0 24.5409 0.166396 25.0172 0.464421 25.3164L0.54141 25.3838L12.8796 12.9947V12.7179L0.531476 0.326416L0.454487 0.393748Z",
			fill: "url(#paint0_linear_380_1793)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.9848 17.1371L12.8696 13.0049V12.7157L16.9848 8.5835L17.0742 8.63836L21.942 11.4164C23.3352 12.2044 23.3352 13.5062 21.942 14.3042L17.0742 17.0822L16.9848 17.1371Z",
			fill: "url(#paint1_linear_380_1793)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.0742 17.0821L12.8696 12.8601L0.454407 25.3264C0.908894 25.8152 1.67134 25.8701 2.52319 25.3938L17.0742 17.0821Z",
			fill: "url(#paint2_linear_380_1793)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.0742 8.6383L2.52319 0.339046C1.67134 -0.149732 0.90641 -0.0824003 0.454407 0.406378L12.8696 12.8602L17.0742 8.6383Z",
			fill: "url(#paint3_linear_380_1793)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .25,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.52327 0.483646L21.942 11.561C22.5728 11.9176 22.928 12.3839 22.9826 12.8602C22.9826 12.339 22.6399 11.8153 21.942 11.4163L2.52327 0.339007C1.13001 -0.461492 0 0.206838 0 1.80534V1.94998C0 0.348982 1.13001 -0.306878 2.52327 0.483646Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_380_1793",
				x1: 11.7729,
				y1: 1.56665,
				x2: -8.00151,
				y2: 6.81395,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#00A0FF" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .00657,
						stopColor: "#00A1FF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .2601,
						stopColor: "#00BEFF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5122,
						stopColor: "#00D2FF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7604,
						stopColor: "#00DFFF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#00E3FF"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_380_1793",
				x1: 23.7589,
				y1: 12.8603,
				x2: -.338814,
				y2: 12.8603,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#FFE000" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .4087,
						stopColor: "#FFBD00"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7754,
						stopColor: "#FFA500"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#FF9C00"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_380_1793",
				x1: 14.7879,
				y1: 15.1575,
				x2: -1.17486,
				y2: 41.9139,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF3A44" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#C31162"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_380_1793",
				x1: -2.67187,
				y1: -6.96097,
				x2: 4.44978,
				y2: 4.98893,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#32A071" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .0685,
						stopColor: "#2DA771"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .4762,
						stopColor: "#15CF74"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8009,
						stopColor: "#06E775"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#00F076"
					})
				]
			})
		] })
	]
});
export default SvgPlayMarket;
